// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var TextInputNew$ReactHooksTemplate = require("../common/TextInputNew.res.js");
var ListCondition$ReactHooksTemplate = require("./ListCondition.res.js");
var MultiSelectDropDown$ReactHooksTemplate = require("../common/MultiSelectDropDown.res.js");

function ListConditionForm(props) {
  var updateCondition = props.updateCondition;
  var listCondition = props.listCondition;
  var operator = ListCondition$ReactHooksTemplate.operator(listCondition);
  var rhs = ListCondition$ReactHooksTemplate.rhs(listCondition);
  var rhs$1 = rhs !== undefined ? rhs : /* [] */0;
  var showRhsField;
  switch (operator) {
    case "is_blank" :
    case "is_not_blank" :
        showRhsField = false;
        break;
    default:
      showRhsField = true;
  }
  var availableOperators = ListCondition$ReactHooksTemplate.availableOperatorsForCondition(listCondition);
  var rhsOptions = ListCondition$ReactHooksTemplate.answerListForCondition(listCondition);
  var handleOperatorChange = function ($$event) {
    var selectedOperator = Utils$ReactHooksTemplate.formTargetValue($$event);
    var updatedCondition;
    switch (selectedOperator) {
      case "is_blank" :
      case "is_not_blank" :
          updatedCondition = ListCondition$ReactHooksTemplate.setRhs(ListCondition$ReactHooksTemplate.setOperator(listCondition, selectedOperator), undefined);
          break;
      default:
        updatedCondition = ListCondition$ReactHooksTemplate.setOperator(listCondition, selectedOperator);
    }
    Curry._1(updateCondition, {
          TAG: "ListCondition",
          _0: updatedCondition
        });
  };
  var handleRhsChange = function (rhsOptions, selectedRhsTexts) {
    var selectedRhs = Belt_List.keep(rhsOptions, (function (param) {
            var text = param[1];
            return Belt_List.some(selectedRhsTexts, (function (x) {
                          return text === x;
                        }));
          }));
    var updatedCondition = ListCondition$ReactHooksTemplate.setRhs(listCondition, selectedRhs);
    Curry._1(updateCondition, {
          TAG: "ListCondition",
          _0: updatedCondition
        });
  };
  var handleRhsInputChange = function (e) {
    var rhs = e.target.value;
    var updatedRhs_0 = [
      "",
      rhs
    ];
    var updatedRhs = {
      hd: updatedRhs_0,
      tl: /* [] */0
    };
    var updatedCondition = ListCondition$ReactHooksTemplate.setRhs(listCondition, updatedRhs);
    Curry._1(updateCondition, {
          TAG: "ListCondition",
          _0: updatedCondition
        });
  };
  var tmp;
  if (showRhsField) {
    var match = ListCondition$ReactHooksTemplate.lhs(listCondition);
    tmp = match.TAG === "Question" ? JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("div", {
                    children: ListCondition$ReactHooksTemplate.isSentimentCondition(listCondition) ? "Sentiment" : "Answer",
                    className: "flex h-20-px font-normal text-xs text-aurometalsaurus "
                  }),
              JsxRuntime.jsx(MultiSelectDropDown$ReactHooksTemplate.make, {
                    defaultPlaceholder: "Select Choices",
                    options: Belt_List.map(rhsOptions, (function (param) {
                            return param[1];
                          })),
                    selectedOptions: Belt_List.map(rhs$1, (function (param) {
                            return param[1];
                          })),
                    handleChange: (function (param) {
                        return handleRhsChange(rhsOptions, param);
                      }),
                    width: "w-full",
                    multiSelect: !(!ListCondition$ReactHooksTemplate.multipleAnswerEnabled(listCondition.lhs) && operator === "equals")
                  })
            ],
            className: "flex flex-col w-7/12 min-w-0"
          }) : (
        !ListCondition$ReactHooksTemplate.multipleAnswerEnabled(listCondition.lhs) && operator === "equals" ? JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                label: "Value",
                value: Belt_List.headExn(Belt_List.map(rhs$1, (function (param) {
                            return param[1];
                          }))),
                handleChange: handleRhsInputChange,
                inputBoxContainerCss: "flex flex-col w-full"
              }) : JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                        children: "Value",
                        className: "flex h-20-px font-normal text-xs text-aurometalsaurus "
                      }),
                  JsxRuntime.jsx(MultiSelectDropDown$ReactHooksTemplate.make, {
                        defaultPlaceholder: "Select Choices",
                        options: Belt_List.map(rhsOptions, (function (param) {
                                return param[1];
                              })),
                        selectedOptions: Belt_List.map(rhs$1, (function (param) {
                                return param[1];
                              })),
                        handleChange: (function (param) {
                            return handleRhsChange(rhsOptions, param);
                          }),
                        width: "w-full",
                        multiSelect: !(!ListCondition$ReactHooksTemplate.multipleAnswerEnabled(listCondition.lhs) && operator === "equals")
                      })
                ],
                className: "flex flex-col w-7/12 min-w-0"
              })
      );
  } else {
    tmp = JsxRuntime.jsx(JsxRuntime.Fragment, {});
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: "Condition",
                              className: "w-48-px h-20-px font-normal text-xs text-aurometalsaurus "
                            }),
                        JsxRuntime.jsx("select", {
                              children: $$Array.of_list(Belt_List.map(availableOperators, (function (operator) {
                                          return JsxRuntime.jsx("option", {
                                                      children: ListCondition$ReactHooksTemplate.humanizeOperator(operator, listCondition),
                                                      className: "text-left bg-white-300 px-2 py-1 hover:bg-gray-300",
                                                      value: operator
                                                    }, operator);
                                        }))),
                              className: "min-h-38-px  px-2 py-1 rounded bg-white border border-gray-300\n                   cursor-pointer focus:border-gray-600 text-xs",
                              placeholder: "Select Operator",
                              value: operator,
                              onChange: handleOperatorChange
                            })
                      ],
                      className: "flex flex-col w-5/12 flex-shrink-0"
                    }),
                tmp
              ],
              className: "flex gap-2 w-full min-w-0"
            });
}

var make = ListConditionForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
